import api from './Api';
import getAuthToken from './helpers';

class CompanyService {
  constructor() {
    this.api = api;
  }

  getCompanyById(companyId) {
    return this.api.get(`/companies/${companyId}`, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  getCompanyForm(companyId) {
    return this.api.get(`/companies/${companyId}/forms`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
  }

  getStatistics(companyId) {
    return this.api.get(`/companies/${companyId}/statistics`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${getAuthToken()}`,
      },
    });
  }

  create(payload) {
    return this.api.post('/companies/onboard', payload);
  }

  update(company) {
    return this.api.put(`/companies/${company.id}`, company);
  }
}

const companyService = new CompanyService();
export default companyService;
